import siFetch from "api/fetch";

const commission = (init = null) => siFetch("/api/v1/revenue/summary", init);

export default commission;
